import React from "react";
import { useTranslation } from "react-i18next";
import { FiZap, FiClock, FiTrendingUp, FiBell, FiBarChart2, FiCpu, FiShoppingBag } from "react-icons/fi";
import Heading from "../../../Components/Heading/Heading";
import SubHeading from "../../../Components/SubHeading/SubHeading";
import TryFreeCTA from "../../../Components/TryFreeCTA/TryFreeCTA";
import styles from "./UseStylon.module.css";
import sesior from "../../../assets/sesior.svg";
import clock from "../../../assets/clock.svg";
import { TEMP_CRM_PIVOT } from "../../../config/tempCrmPivot";

const UseStylon = () => {
  const { t } = useTranslation();
  const u = TEMP_CRM_PIVOT ? "tempPivot.useStylon" : "useStylon";

  const detail1 = TEMP_CRM_PIVOT
    ? [
        { titleKey: "useStylon.easyToUse", contentKey: "useStylon.easyToUseContent", Icon: FiZap },
        { titleKey: `${u}.doMoreWithYourTime`, contentKey: `${u}.doMoreWithYourTimeContent`, Icon: FiClock },
        { titleKey: `${u}.moreVisible`, contentKey: `${u}.moreVisibleContent`, Icon: FiTrendingUp },
      ]
    : [
        { titleKey: "useStylon.easyToUse", contentKey: "useStylon.easyToUseContent", Icon: FiZap },
        { titleKey: "useStylon.doMoreWithYourTime", contentKey: "useStylon.doMoreWithYourTimeContent", Icon: FiClock },
        { titleKey: "useStylon.moreVisible", contentKey: "useStylon.moreVisibleContent", Icon: FiTrendingUp },
      ];

  const detail2 = TEMP_CRM_PIVOT
    ? [
        { titleKey: `${u}.productSales`, contentKey: `${u}.productSalesContent`, Icon: FiShoppingBag },
        { titleKey: "useStylon.insightsAndTips", contentKey: "useStylon.insightsAndTipsContent", Icon: FiBarChart2 },
        { titleKey: "useStylon.aiAssistant", contentKey: "useStylon.aiAssistantContent", Icon: FiCpu },
      ]
    : [
        { titleKey: "useStylon.smartReminders", contentKey: "useStylon.smartRemindersContent", Icon: FiBell },
        { titleKey: "useStylon.insightsAndTips", contentKey: "useStylon.insightsAndTipsContent", Icon: FiBarChart2 },
        { titleKey: "useStylon.aiAssistant", contentKey: "useStylon.aiAssistantContent", Icon: FiCpu },
      ];

  return (
    <div className={styles.mainBOx}>
      <section className={`text-center my-4 ${styles.mainHeading}`}>
        <Heading text={t("useStylon.heading")} />
        <img src={sesior} className={styles.sesior} alt="" />
      </section>
      <div className={`container ${styles.parent}`}>
        <section className={styles.child1}>
          {detail1.map((v, i) => {
            const Icon = v.Icon;
            return (
              <div key={i} data-aos="fade-up" data-aos-duration="500" className={styles.bulletCard}>
                <section className={styles.headingBox}>
                  <span className={styles.bulletIcon}><Icon /></span>
                  <SubHeading text={t(v.titleKey)} />
                </section>
                <section className={styles.paraBox}>
                  <p>{t(v.contentKey)}</p>
                </section>
              </div>
            );
          })}
        </section>
        <section className={styles.child2}>
          {detail2.map((v, i) => {
            const Icon = v.Icon;
            return (
              <div key={i} data-aos="fade-up" data-aos-duration="500" className={styles.bulletCard}>
                <section className={styles.headingBox}>
                  <span className={styles.bulletIcon}><Icon /></span>
                  <SubHeading text={t(v.titleKey)} />
                </section>
                <section className={styles.paraBox}>
                  <p>{t(v.contentKey)}</p>
                </section>
              </div>
            );
          })}
        </section>
        <img src={clock} className={styles.clock} alt="" />
      </div>
      <TryFreeCTA className={styles.ctaWrap} section="use_stylon" />
    </div>
  );
};

export default UseStylon;
